export default __webpack_public_path__ + "static/media/ImgGift05.c7f71f92.jpg";